(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-grid"] && !Shopify.designMode) return;
  try {
    
/* ══════════════════════════════════════════════════════════
   Installed work: the two-level filter and the photograph overlay.

   Ported from site/assets/js/cases.js. The behaviour is the original's; the hooks are this
   section's, because the cards are metaobject entries rather than 24 hand-written buttons.
   What must not drift from the original:

   · Choosing a line shows that line's sub-chips and hides the others. Choosing a sub-chip
     does not clear the line - the two read together, `gates:European Classic`.
   · The counter is "shown / total", and the total never moves.
   · A chip counting 0 renders disabled rather than hidden, so "Pavilions 0" stays visible
     and honest.
   · Closing the overlay returns focus to the card that opened it.

   ⚠ The testimonial carousel is NOT here. hm-testimonials owns it, and both bands sit on
     the cases page - binding those arrows twice scrolls two cards per click.
   ══════════════════════════════════════════════════════════ */
(function () {
  var grid = document.querySelector("[data-cs-grid]");
  if (!grid) return;

  var cards = [].slice.call(grid.querySelectorAll(".cs-card"));
  var chips = [].slice.call(document.querySelectorAll(".cs-chip"));
  var subRows = [].slice.call(document.querySelectorAll("[data-sub]"));
  var brks = [].slice.call(grid.querySelectorAll("[data-brk]"));
  var countEl = document.querySelector("[data-cs-count]");
  var emptyEl = document.querySelector("[data-cs-empty]");
  var resetEl = document.querySelector("[data-cs-reset]");

  /* ── the filter ─────────────────────────────────────── */
  var active = "";

  function shows(card) {
    if (!active) return true;
    var hay = "|" + (card.getAttribute("data-cat") || "") + "|";
    return hay.indexOf("|" + active + "|") > -1;
  }

  function apply() {
    var n = 0;
    cards.forEach(function (c) {
      var on = shows(c);
      c.hidden = !on;
      if (on) n++;
    });
    if (countEl) countEl.textContent = n;
    if (emptyEl) emptyEl.hidden = n !== 0;

    /* The breaks belong to the rhythm of the whole grid. Under a filter they read as a
       heading for whatever follows, and on a two-card result they can be most of the
       screen - so the original shows them under All only. */
    brks.forEach(function (b) { b.style.display = active ? "none" : ""; });

    /* The line half of `gates:European Classic` decides which sub-row is open. */
    var line = active.split(":")[0];
    subRows.forEach(function (r) {
      r.hidden = r.getAttribute("data-sub") !== line;
    });
  }

  chips.forEach(function (ch) {
    ch.addEventListener("click", function () {
      var f = ch.getAttribute("data-f") || "";
      /* Clicking the chip already on clears it, so a visitor is never stuck inside a
         filter with no way back to everything. */
      active = (f === active) ? "" : f;
      chips.forEach(function (o) {
        var on = (o.getAttribute("data-f") || "") === active;
        o.classList.toggle("is-on", on);
        o.setAttribute("aria-pressed", on ? "true" : "false");
      });
      apply();
    });
  });

  if (resetEl) resetEl.addEventListener("click", function () {
    active = "";
    chips.forEach(function (o) {
      var on = !o.getAttribute("data-f");
      o.classList.toggle("is-on", on);
      o.setAttribute("aria-pressed", on ? "true" : "false");
    });
    apply();
  });

  /* ── the overlay ────────────────────────────────────── */
  var lb = document.getElementById("csLb"),
      rail = document.getElementById("csLbR"),
      lbT = document.getElementById("csLbT"),
      lbS = document.getElementById("csLbS"),
      lbC = document.getElementById("csLbC"),
      lbD = document.getElementById("csLbD"),
      lbX = document.getElementById("csLbX"),
      last = null;

  function txt(card, sel) {
    var el = card.querySelector(sel);
    return el ? el.textContent.trim() : "";
  }

  function open(card) {
    if (!lb) return false;
    var tpl = grid.querySelector('template[data-set="' + card.getAttribute("data-set") + '"]');
    if (!tpl) return false;               /* one photograph: nothing to page through */
    rail.innerHTML = "";
    rail.appendChild(tpl.content.cloneNode(true));
    lbT.textContent = txt(card, ".cs-t");
    lbS.textContent = txt(card, ".cs-s");
    var n = rail.children.length, dots = "";
    for (var k = 0; k < n; k++) dots += '<i class="' + (k ? "" : "on") + '"></i>';
    lbD.innerHTML = dots;
    lbC.textContent = "1 / " + n;
    last = card;
    lb.hidden = false;
    document.body.style.overflow = "hidden";
    rail.scrollLeft = 0;
    lbX.focus();
    return true;
  }

  function close() {
    if (!lb) return;
    lb.hidden = true;
    document.body.style.overflow = "";
    if (last) last.focus();
  }

  cards.forEach(function (c) {
    c.addEventListener("click", function () { open(c); });
  });
  if (lbX) lbX.addEventListener("click", close);
  if (lb) lb.addEventListener("click", function (e) { if (e.target === lb) close(); });

  document.addEventListener("keydown", function (e) {
    if (!lb || lb.hidden) return;
    if (e.key === "Escape") { close(); return; }
    if (e.key === "Tab") {
      /* Focus stays inside the overlay; without this, Tab walks off into the page behind
         it and a keyboard visitor has no idea where they have gone. */
      var f = [].slice.call(lb.querySelectorAll("button, a[href]"))
                .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], lastF = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastF.focus(); }
      else if (!e.shiftKey && document.activeElement === lastF) { e.preventDefault(); first.focus(); }
    }
  });

  /* The rail is a native horizontal scroller; the counter and dots follow it. */
  var t;
  if (rail) rail.addEventListener("scroll", function () {
    clearTimeout(t);
    t = setTimeout(function () {
      var kids = rail.children, n = kids.length;
      if (!n) return;
      var mid = rail.scrollLeft + rail.clientWidth / 2, best = Infinity, at = 0;
      for (var k = 0; k < n; k++) {
        var c = kids[k].offsetLeft + kids[k].offsetWidth / 2, d = Math.abs(c - mid);
        if (d < best) { best = d; at = k; }
      }
      lbC.textContent = (at + 1) + " / " + n;
      [].forEach.call(lbD.children, function (dot, k) { dot.classList.toggle("on", k === at); });
    }, 60);
  }, { passive: true });

  apply();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ct-desk"]) return;
  try {
    
/* ═══════════════════════════════════════════════════════════
   contact.html 独有交互 —— 「三道门在联系页的延续」

   四件事：
   1. 身份切换：左边选「你是谁」→ 右侧深色台整块换脸（谁接手 / 带什么 /
      回什么），同时第 06 个字段换问法、按钮换文案、路由提示条换颜色。
      手机上深色台在表单上方，所以还有一条就地的路由提示条做反馈。
   2. 时区承诺：几个城市的当地时间 + 「我们 09–18 在你那边是几点」，
      全部用 Intl 现算（含夏令时），不写死偏移。合肥的大钟由 site.js
      的 [data-hefei] 负责，这支不碰。
   3. 附件：只在浏览器里列出文件名，支持拖放，不上传。
   4. 提交：拦下来，出一张「收据」说明这是演示、什么都没发出去。

   踩过的坑：
   · 三张脸是叠在同一格里的，隐藏的那两张里有链接 —— 必须给它们
     tabindex=-1，不然键盘会 Tab 进看不见的地方。
   · 用户输入一律用 textContent 写进收据，绝不拼 innerHTML。
   · 其它十页也加载 site.js 但不加载这支；即便加载了，
     找不到 [data-ct-form] / [data-ct-zones] 就各自安全退出。
   ═══════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ══════════ 1 · 身份 → 换脸 ══════════ */

  var DESKS = {
    con: {
      name: "Contractor desk",
      cta: "Send to the contractor desk",
      ctx: "Project or drawing reference",
      ph: "Job name, phase, drawing number",
      help: "Whatever identifies the phase — it travels with the numbers and comes back " +
            "on the quote.",
      route: "Contractor desk — bring drawings, quantities, finish and site dates."
    },
    dis: {
      name: "Distributor desk",
      cta: "Send to the distributor desk",
      ctx: "Territory you cover",
      ph: "Country, region or city",
      help: "One country holds one signed distributor. Dealer pricing is issued on " +
            "application, never published here.",
      route: "Distributor desk — territory first, then range, then terms in writing."
    },
    own: {
      name: "Homeowner desk",
      cta: "Send to the homeowner desk",
      ctx: "Opening width × height",
      ph: "e.g. 3600 × 1800 mm — an estimate is fine",
      help: "A tape-measure estimate is enough to start the drawing. Measured properly " +
            "before anything is cut.",
      route: "Homeowner desk — one opening, drawn before anything is cut."
    }
  };
  var KCLASS = { con: "k-con", dis: "k-dis", own: "k-own" };

  var form   = $("[data-ct-form]");
  var faces  = $("[data-ct-faces]");
  var route  = $("[data-ct-route]");
  var radios = $$('input[data-ct-who]');

  function face(k) { return faces ? $('[data-face="' + k + '"]', faces) : null; }

  function showFace(k) {
    if (!faces) return;
    $$(".ct-face", faces).forEach(function (el) {
      var on = el.getAttribute("data-face") === k;
      el.classList.toggle("is-on", on);
      el.setAttribute("aria-hidden", on ? "false" : "true");
      // 隐藏的脸里有链接：不让键盘 Tab 进去
      $$("a[href]", el).forEach(function (a) {
        if (on) a.removeAttribute("tabindex"); else a.setAttribute("tabindex", "-1");
      });
    });
  }

  function pick(k) {
    var d = DESKS[k];
    if (!d) return;

    showFace(k);

    if (route) {
      route.classList.remove("k-con", "k-dis", "k-own");
      route.classList.add("is-set", KCLASS[k]);
      var rt = $(".ct-route-t", route);
      if (rt) rt.textContent = d.route;
    }

    var cta = $("[data-ct-cta]");
    if (cta) cta.textContent = d.cta;

    var lab = $("[data-ct-ctx-label]");
    if (lab) lab.textContent = d.ctx;
    var inp = $("[data-ct-ctx-input]");
    if (inp) inp.setAttribute("placeholder", d.ph);
    var help = $("[data-ct-ctx-help]");
    if (help) help.textContent = d.help;
  }

  if (radios.length) {
    radios.forEach(function (r) {
      r.addEventListener("change", function () {
        if (r.checked) pick(r.getAttribute("data-ct-who"));
      });
    });
    // 浏览器可能恢复上次的选择（后退 / 刷新），进来先同步一次
    var pre = radios.filter(function (r) { return r.checked; })[0];
    if (pre) pick(pre.getAttribute("data-ct-who")); else showFace("none");
  }

  /* ══════════ 2 · 时区承诺 ══════════ */

  var zonesBox = $("[data-ct-zones]");
  if (zonesBox) (function () {
    var rows = $$(".ct-zone[data-tz]", zonesBox);
    var HOME = "Asia/Shanghai";      // 合肥没有独立 IANA 区，用上海，同一个 +8
    var OPEN = 9 * 60, CLOSE = 18 * 60;

    function pad(n) { return (n < 10 ? "0" : "") + n; }

    function partsIn(tz, d) {
      var f = new Intl.DateTimeFormat("en-GB", {
        timeZone: tz, hour12: false, year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit"
      });
      var o = {};
      f.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
      return o;
    }
    // 该时区相对 UTC 的偏移（分钟），含夏令时 —— 不写死数字
    function offsetMin(tz, d) {
      var p = partsIn(tz, d);
      var h = parseInt(p.hour, 10) % 24;               // 某些实现半夜给 "24"
      var asUTC = Date.UTC(+p.year, p.month - 1, +p.day, h, +p.minute, +p.second);
      return Math.round((asUTC - (d.getTime() - d.getMilliseconds())) / 60000);
    }
    function clockOf(mins) {
      var m = ((mins % 1440) + 1440) % 1440;
      return pad(Math.floor(m / 60)) + ":" + pad(m % 60);
    }

    function tick() {
      var now = new Date(), home, openNow = false;
      try {
        home = offsetMin(HOME, now);
        var hp = partsIn(HOME, now);
        var hm = parseInt(hp.hour, 10) * 60 + parseInt(hp.minute, 10);
        openNow = hm >= OPEN && hm < CLOSE;                        // 合肥这会儿在不在上班
      } catch (e) { return; }                                      // 老引擎：保留占位横线
      rows.forEach(function (row) {
        var tz = row.getAttribute("data-tz");
        var nEl = $("[data-z-now]", row), wEl = $("[data-z-win]", row);
        try {
          var p = partsIn(tz, now);
          if (nEl) nEl.textContent = p.hour + ":" + p.minute;
          var diff = offsetMin(tz, now) - home;
          if (wEl) wEl.textContent = clockOf(OPEN + diff) + "–" + clockOf(CLOSE + diff);
          /* 圆点 = 两头都在桌前：合肥在上班时间，且那座城市当地 08–20 之间。
             （别用「此刻是否落在我们的时段里」—— 那个对每一行都同真同假，
             整列一起亮，等于没说。） */
          var here = parseInt(p.hour, 10) * 60 + parseInt(p.minute, 10);
          row.classList.toggle("is-live", openNow && here >= 480 && here < 1200);
        } catch (err) { /* 单个时区不认就跳过，别拖垮整块 */ }
      });
    }

    tick();
    setInterval(tick, 30000);

    /* 逐行点亮：IO 为主，滚动 + 定时兜底（面板可能一进来就在视口里）*/
    var lit = false;
    function light() {
      if (lit) return;
      lit = true;
      if (reduced) { rows.forEach(function (r) { r.classList.add("lit"); }); return; }
      rows.forEach(function (r, i) {
        setTimeout(function () { r.classList.add("lit"); }, 90 + i * 110);
      });
    }
    if (reduced) {
      light();
    } else if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { light(); io.disconnect(); } });
      }, { rootMargin: "0px 0px -6% 0px", threshold: 0.15 });
      io.observe(zonesBox);
    }
    function sweep() {
      if (lit) { removeEventListener("scroll", sweep); return; }
      if (zonesBox.getBoundingClientRect().top < (innerHeight || 800) * 0.92) light();
    }
    addEventListener("scroll", sweep, { passive: true });
    sweep(); requestAnimationFrame(sweep); setTimeout(sweep, 800);
  })();

  /* ══════════ 3 · 附件：只在本地列出来 ══════════ */

  var fileIn = $("[data-ct-drop] input[type=file]");
  var dropEl = $("[data-ct-drop]");
  var fileUl = $("[data-ct-files]");
  var clearB = $("[data-ct-clear]");

  function sizeOf(b) {
    if (b < 1024) return b + " B";
    if (b < 1048576) return Math.round(b / 1024) + " KB";
    return (b / 1048576).toFixed(1) + " MB";
  }

  function paintFiles() {
    if (!fileIn || !fileUl) return;
    var fs = fileIn.files ? [].slice.call(fileIn.files) : [];
    fileUl.textContent = "";
    fs.forEach(function (f) {
      var li = document.createElement("li");
      li.className = "ct-fi";
      var a = document.createElement("span");
      a.textContent = f.name;                       // 文件名一律 textContent
      var b = document.createElement("span");
      b.className = "code";
      b.textContent = sizeOf(f.size);
      li.appendChild(a); li.appendChild(b);
      fileUl.appendChild(li);
    });
    if (clearB) clearB.hidden = !fs.length;
  }

  if (fileIn) {
    fileIn.addEventListener("change", paintFiles);
    if (clearB) clearB.addEventListener("click", function () {
      try { fileIn.value = ""; } catch (e) {}
      paintFiles();
      fileIn.focus();
    });
  }
  if (dropEl && fileIn) {
    ["dragenter", "dragover"].forEach(function (t) {
      dropEl.addEventListener(t, function (e) {
        e.preventDefault(); dropEl.classList.add("is-over");
      });
    });
    ["dragleave", "dragend", "drop"].forEach(function (t) {
      dropEl.addEventListener(t, function () { dropEl.classList.remove("is-over"); });
    });
    dropEl.addEventListener("drop", function (e) {
      if (!e.dataTransfer || !e.dataTransfer.files || !e.dataTransfer.files.length) return;
      e.preventDefault();
      try { fileIn.files = e.dataTransfer.files; } catch (err) { /* 老浏览器不给赋值 */ }
      paintFiles();
    });
  }

  /* ══════════ 4 · submission ══════════
     Nothing to do here. The form posts to Shopify and the page comes back with
     `form.posted_successfully?`, which is what reveals the confirmation panel — so the
     panel cannot appear for something that was not sent, and no script has to reveal it.

     The demo's summary builder lived here: it read the form and listed what WOULD have
     been sent. It is gone, along with its markup and its rules. Shopify does not hand the
     posted values back to the template, so there is nothing to build such a list from, and
     the panel says what happened instead. */

  var again = $("[data-ct-again]");
  if (again && form && done) {
    again.addEventListener("click", function () {
      done.hidden = true;
      form.hidden = false;
      var first = $("#ct-name", form);
      var y = form.getBoundingClientRect().top + scrollY - 96;
      scrollTo({ top: y, behavior: reduced ? "auto" : "smooth" });
      if (first) first.focus({ preventScroll: true });
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ct-measure"] && !Shopify.designMode) return;
  try {
    
/* One elevation, annotated a line at a time: whichever note you have scrolled to draws
   its dimension lines, leaders and labels on the drawing, and nothing already drawn is
   erased — the sheet fills up as you read it.

   Notes:
   - base.css's .dw cannot be used. .dw draws a whole SVG in one pass; this needs one
     group at a time, so lengths are measured here, written to --L, and the classes are
     added here too.
   - Main path is an IntersectionObserver on each note; where IO is unavailable or never
     fires, a throttled scroll listener picks the note nearest the viewport middle. Both
     call the same show(), which is idempotent.
   - This file is loaded on every page of the theme. With no [data-ct-sheet] it returns
     immediately rather than throwing. */
(function () {
  "use strict";

  var root = document.querySelector("[data-ct-sheet]");
  if (!root) return;

  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  var anns  = $$("[data-ann]", root);
  var notes = $$("[data-note]", root);
  var chips = $$("[data-chip]", root);
  var outK  = root.querySelector("[data-cur-k]");
  var outN  = root.querySelector("[data-cur-n]");
  if (!anns.length || !notes.length) return;

  var n = Math.min(anns.length, notes.length);
  var reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* 1 - measure each stroke, write --L.
     Only shapes that are actually stroked. circle.ct-dot is a filled dot. */
  anns.forEach(function (g) {
    $$("path,line,polyline", g).forEach(function (el, i) {
      var len = 0;
      try { len = el.getTotalLength ? el.getTotalLength() : 0; } catch (e) { len = 0; }
      if (!len) {
        var b = null;
        try { b = el.getBBox ? el.getBBox() : null; } catch (e) { b = null; }
        len = b ? (b.width + b.height) * 2 : 400;
      }
      el.style.setProperty("--L", Math.ceil(len) + 1);
      if (!reduced) el.style.transitionDelay = (i * 70) + "ms";
    });
  });

  /* 2 - show up to note i. Cumulative; never rolls back. */
  var cur = -1;
  function show(i) {
    if (i < 0) i = 0;
    if (i > n - 1) i = n - 1;

    for (var k = 0; k <= i; k++) {
      anns[k].classList.add("is-on");
      if (chips[k]) chips[k].classList.add("is-on");
    }
    if (cur === i) return;
    cur = i;

    for (var j = 0; j < n; j++) {
      anns[j].classList.toggle("is-cur", j === i);
      notes[j].classList.toggle("is-cur", j === i);
    }
    if (outK) outK.textContent = notes[i].getAttribute("data-note") || "";
    if (outN) outN.textContent = notes[i].getAttribute("data-title") || "";
  }

  /* Reduced motion: mark the sheet up in full, bind nothing */
  if (reduced) { show(n - 1); return; }

  /* 3 - main path: IntersectionObserver.
     A note is current while it is in the middle band (44% clipped top and bottom). */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = notes.indexOf(e.target);
        if (i > -1) show(i);
      });
    }, { rootMargin: "-44% 0px -44% 0px", threshold: 0 });
    notes.forEach(function (el) { io.observe(el); });
  }

  /* 4 - fallback: on scroll, take the note nearest the viewport middle.
     IO does not fire at all in some embedded / background contexts, and rAF is frozen in
     background tabs — so this path is throttled on a timestamp and does not use rAF.
     Both paths call the same show(); calling it twice costs nothing. */
  function pick() {
    var vh = window.innerHeight || 800;
    var box = root.getBoundingClientRect();

    if (box.bottom <= 0) { show(n - 1); return; }   // scrolled past - mark it all up
    if (box.top > vh) return;                        // not in yet

    var mid = vh * 0.5, best = -1, bd = Infinity;
    for (var i = 0; i < n; i++) {
      var r = notes[i].getBoundingClientRect();
      var d = Math.abs(r.top + r.height / 2 - mid);
      if (d < bd) { bd = d; best = i; }
    }
    if (best > -1) show(best);
  }
  var last = 0, trail = 0;
  function onScroll() {
    var now = Date.now();
    if (now - last > 90) { last = now; pick(); return; }
    clearTimeout(trail);
    trail = setTimeout(function () { last = Date.now(); pick(); }, 90);
  }

  addEventListener("scroll", onScroll, { passive: true });
  addEventListener("resize", onScroll);
  pick();
  setTimeout(pick, 300);
  setTimeout(pick, 900);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-apply"] && !Shopify.designMode) return;
  try {
    
/* ═══════════════════════════════════════════════════════════
   for-distributors.html — 本页独有交互

   2026-08：装柜示意图（滚动逐件装货那套）连同它的脚本一起删了。
   页面砍到五块，全部询盘走 WhatsApp / 邮箱，这里只剩一件事 ——
   把号码和邮箱做成可一键复制。

   为什么值得写这几十行：
   · 北美 WhatsApp 渗透率只有 23%。点 wa.me 对他们经常是死链，
     真正要的是那串号码本身能整段抄进他自己的通讯录。
   · 桌面端没登录 WhatsApp Web 的人同理。
   · 双击本地文件打开时是 file://，不是 secure context，
     navigator.clipboard 会直接抛 —— 必须留 execCommand 兜底。
   · 纯增强：按钮是 JS 加的，没有 JS 时号码本身照样是明文可选中的。
   ═══════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var fields = [].slice.call(document.querySelectorAll("[data-ds-copy]"));
  if (!fields.length) return;                 // 不是这一页，安静退出

  /* 复制结果播报给读屏，不要只靠按钮上那两个字变色 */
  var say = document.createElement("p");
  say.className = "vh";
  say.setAttribute("role", "status");
  say.setAttribute("aria-live", "polite");
  say.style.cssText = "position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)";
  document.body.appendChild(say);

  /* 老办法。选区要先存后还，否则会把用户自己的选中弄没。 */
  function legacy(text) {
    var ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.cssText = "position:fixed;top:0;left:-9999px;opacity:0";
    document.body.appendChild(ta);
    var sel = document.getSelection();
    var keep = sel && sel.rangeCount ? sel.getRangeAt(0) : null;
    ta.select();
    var done = false;
    try { done = document.execCommand("copy"); } catch (e) { done = false; }
    document.body.removeChild(ta);
    if (keep && sel) { sel.removeAllRanges(); sel.addRange(keep); }
    return done;
  }

  function write(text) {
    /* clipboard API 会因为「文档没聚焦」这类临时原因直接 reject，
       那时候老办法往往还是成的 —— 所以是二次兜底，不是二选一。 */
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        return legacy(text) ? undefined : Promise.reject();
      });
    }
    return legacy(text) ? Promise.resolve() : Promise.reject();
  }

  fields.forEach(function (el) {
    var value = el.getAttribute("data-ds-copy");
    var label = (el.previousElementSibling && el.previousElementSibling.textContent || "value").trim();

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ds-copy";
    btn.textContent = "Copy";
    btn.setAttribute("aria-label", "Copy " + label + " to clipboard");

    var back = null;
    btn.addEventListener("click", function () {
      write(value).then(function () {
        btn.textContent = "Copied";
        say.textContent = label + " copied.";
      }, function () {
        /* 复制不了就别假装成功 —— 直接选中，让他自己按 Ctrl+C */
        btn.textContent = "Select it";
        say.textContent = label + " could not be copied; it is selected instead.";
        var r = document.createRange();
        r.selectNodeContents(el);
        var s = document.getSelection();
        if (s) { s.removeAllRanges(); s.addRange(r); }
      });
      clearTimeout(back);
      back = setTimeout(function () { btn.textContent = "Copy"; }, 2400);
    });

    el.parentNode.appendChild(btn);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-overlay"] && !Shopify.designMode) return;
  try {
    
/* ═══════════════════════════════════════════════════════════
   for-homeowners.js · 业主门
   这一页只剩一件互动的事（2026-08 砍薄，before/after 对比滑块已删）：

     线稿门叠在真实安装照上
       照片**完全不离开浏览器**：URL.createObjectURL 本地读，
       不上传、不请求、不存。页面上把这句话写出来了，代码就必须对得起它。

   踩过的坑：
   · 拖动一律走 pointer 事件 + setPointerCapture，不要分别写 mouse / touch。
   · 指针被浏览器接管去滚页面时只会发 pointercancel，必须一起收尾。
   · 门型切换只能改 opacity，不能 display:none ——
     site.js 量不到隐藏元素的路径长，描边动画会把门画成一条线。
   ═══════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

  var root = document.querySelector("[data-ov]");
  if (!root) return;
  var stage = root.querySelector("[data-ov-stage]");
  var ghost = root.querySelector("[data-ov-ghost]");
  var photo = root.querySelector("[data-ov-photo]");
  if (!stage || !ghost || !photo) return;

  var wIn = root.querySelector("[data-ov-w]");
  var file = root.querySelector("[data-ov-file]");
  var reset = root.querySelector("[data-ov-reset]");
  var hint = root.querySelector("[data-ov-hint]");
  var badge = root.querySelector("[data-ov-badge]");
  var arts = [].slice.call(root.querySelectorAll("[data-ov-art]"));
  var styles = [].slice.call(root.querySelectorAll("[data-ov-style]"));

  var HOME = { x: 44, y: 99, w: 40 };
  var st = { x: HOME.x, y: HOME.y, w: HOME.w };
  var srcWas = photo.getAttribute("src");
  var altWas = photo.getAttribute("alt");
  var badgeWas = badge ? badge.textContent : "";
  var hintWas = hint ? hint.textContent : "";
  var objUrl = null;

  function paint() {
    ghost.style.setProperty("--x", st.x.toFixed(2) + "%");
    ghost.style.setProperty("--y", st.y.toFixed(2) + "%");
    ghost.style.setProperty("--w", st.w.toFixed(2) + "%");
    if (wIn && +wIn.value !== Math.round(st.w)) wIn.value = Math.round(st.w);
  }
  function say(t) { if (hint) hint.textContent = t; }

  /* 键盘也要能摆位 —— 这些属性由 JS 加，没 JS 时它就只是一张图 */
  ghost.setAttribute("tabindex", "0");
  ghost.setAttribute("role", "application");
  ghost.setAttribute("aria-label",
    "Drawn gate on the photograph. Arrow keys move it, plus and minus change its width.");

  /* ── 拖动 ─────────────────────────────────────────────── */
  var down = false, offX = 0, offY = 0;
  ghost.addEventListener("pointerdown", function (e) {
    if (e.pointerType === "mouse" && e.button !== 0) return;
    var r = stage.getBoundingClientRect();
    if (!r.width || !r.height) return;
    down = true;
    root.classList.add("is-drag");
    try { ghost.setPointerCapture(e.pointerId); } catch (err) { /* 老 webview */ }
    offX = ((e.clientX - r.left) / r.width) * 100 - st.x;
    offY = ((e.clientY - r.top) / r.height) * 100 - st.y;
    e.preventDefault();
  });
  ghost.addEventListener("pointermove", function (e) {
    if (!down) return;
    var r = stage.getBoundingClientRect();
    if (!r.width || !r.height) return;
    st.x = clamp(((e.clientX - r.left) / r.width) * 100 - offX, 6, 94);
    st.y = clamp(((e.clientY - r.top) / r.height) * 100 - offY, 22, 100);
    paint();
  });
  ["pointerup", "pointercancel"].forEach(function (t) {
    ghost.addEventListener(t, function () { down = false; root.classList.remove("is-drag"); });
  });
  ghost.addEventListener("dragstart", function (e) { e.preventDefault(); });

  ghost.addEventListener("keydown", function (e) {
    var s = e.shiftKey ? 5 : 1.5, hit = true;
    switch (e.key) {
      case "ArrowLeft": st.x = clamp(st.x - s, 6, 94); break;
      case "ArrowRight": st.x = clamp(st.x + s, 6, 94); break;
      case "ArrowUp": st.y = clamp(st.y - s, 22, 100); break;
      case "ArrowDown": st.y = clamp(st.y + s, 22, 100); break;
      case "+": case "=": st.w = clamp(st.w + s, 14, 78); break;
      case "-": case "_": st.w = clamp(st.w - s, 14, 78); break;
      default: hit = false;
    }
    if (hit) { e.preventDefault(); paint(); }
  });

  /* ── 宽度 ─────────────────────────────────────────────── */
  if (wIn) {
    wIn.addEventListener("input", function () {
      st.w = clamp(+wIn.value || HOME.w, 14, 78);
      paint();
    });
  }

  /* ── 换门型 ───────────────────────────────────────────── */
  styles.forEach(function (b) {
    b.addEventListener("click", function () {
      var key = b.getAttribute("data-ov-style");
      styles.forEach(function (o) {
        var on = o === b;
        o.classList.toggle("is-on", on);
        o.setAttribute("aria-pressed", on ? "true" : "false");
      });
      arts.forEach(function (a) {
        a.classList.toggle("is-on", a.getAttribute("data-ov-art") === key);
      });
    });
  });

  /* ── 换成自己的照片（只在本地，不上传）────────────────── */
  function load(f) {
    if (!f) return;
    if (!/^image\//.test(f.type)) {
      say("Not an image — a JPG or PNG off your phone is perfect.");
      return;
    }
    if (objUrl) URL.revokeObjectURL(objUrl);
    objUrl = URL.createObjectURL(f);
    photo.setAttribute("src", objUrl);
    photo.setAttribute("alt", "Your own photograph, opened in this browser only.");
    root.classList.add("is-own");
    if (badge) badge.textContent = "Your photo · never leaves this browser";
    say("Your gateway. Drag the gate into the opening, then set the width.");
  }

  if (file) {
    file.addEventListener("change", function (e) {
      load(e.target.files && e.target.files[0]);
    });
  }

  /* 拖一张照片进舞台也算 */
  ["dragenter", "dragover"].forEach(function (t) {
    stage.addEventListener(t, function (e) { e.preventDefault(); root.classList.add("is-over"); });
  });
  ["dragleave", "drop"].forEach(function (t) {
    stage.addEventListener(t, function (e) { e.preventDefault(); root.classList.remove("is-over"); });
  });
  stage.addEventListener("drop", function (e) {
    if (e.dataTransfer && e.dataTransfer.files) load(e.dataTransfer.files[0]);
  });

  if (reset) {
    reset.addEventListener("click", function () {
      if (objUrl) { URL.revokeObjectURL(objUrl); objUrl = null; }
      photo.setAttribute("src", srcWas);
      photo.setAttribute("alt", altWas);
      root.classList.remove("is-own");
      if (badge) badge.textContent = badgeWas;
      if (file) file.value = "";
      st.x = HOME.x; st.y = HOME.y; st.w = HOME.w;
      paint();
      say(hintWas);
    });
  }

  paint();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-hero"] && !Shopify.designMode) return;
  try {
    
/* ══ site/assets/js/index.js, carried over unchanged ══
   Pauses the hero film when it leaves the viewport, and never starts it for a
   visitor who has asked for reduced motion. The section emits [data-hero], which
   is what this reads; without the file the attribute was a dead hook and the
   video decoded for as long as the page stayed open. ══ */
(function () {
  var hero = document.querySelector("[data-hero]");
  if (!hero) return;
  var v = hero.querySelector("video");
  if (!v) return;

  if (matchMedia("(prefers-reduced-motion: reduce)").matches) { v.pause(); return; }
  if (!("IntersectionObserver" in window)) return;

  new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: 0.08 }).observe(hero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-testimonials"] && !Shopify.designMode) return;
  try {
    
/* Full-quote rail: the two buttons and the progress bar. The track swipes without this. */
(function () {
  var track = document.querySelector('[data-ts-track]');
  if (!track) return;
  var prev = document.querySelector('[data-ts-prev]');
  var next = document.querySelector('[data-ts-next]');
  var rail = document.querySelector('[data-ts-rail]');

  function step() {
    var c = track.querySelector('.ts-c');
    return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
  }
  function sync() {
    var max = track.scrollWidth - track.clientWidth;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
    if (rail) {
      var frac = track.clientWidth / track.scrollWidth;
      rail.style.width = Math.max(8, frac * 100) + '%';
      rail.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - frac * 100) : 0) + '%';
    }
  }
  if (prev) prev.addEventListener('click', function () {
    track.scrollBy({ left: -step(), behavior: 'smooth' });
  });
  if (next) next.addEventListener('click', function () {
    track.scrollBy({ left: step(), behavior: 'smooth' });
  });
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-process"] && !Shopify.designMode) return;
  try {
    
/* ══ site/assets/js/factory.js, carried over unchanged ══
   Four jobs, and every one of them was missing until now:
     · the rail counter and the dot pager follow the scroll
     · the jump bar highlights the stop you are looking at and scrolls itself to it
     · the loop films play only while on screen, and pause when they leave
     · a full film's poster is attached when its panel opens, not on page load
   The hooks it reads - [data-rail], .fc-st, .fc-st-c b, .fc-dots i, .fc-bar-c a,
   .fc-vid video, .fc-watch, video[data-poster] - are all emitted above. ══ */
(function () {
  "use strict";

  /* ── 每条轨道的计数与圆点 ── */
  document.querySelectorAll("[data-rail]").forEach(function (rail) {
    var st = rail.closest(".fc-st");
    if (!st) return;
    /* Photographs only. The loop film (.fc-vid) is the frame the rail opens on,
       not a numbered view - factory.html labels a film-plus-two-photographs rail
       "1 / 2". Counting it here would make the counter reach 3 against a label
       that says 2 and only two dots, which is what the static page does. */
    var figs = [].slice.call(rail.querySelectorAll("figure"))
                 .filter(function (f) { return !f.classList.contains("fc-vid"); }),
        cnt = st.querySelector(".fc-st-c b"),
        dots = st.querySelectorAll(".fc-dots i"),
        t;
    rail.addEventListener("scroll", function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var mid = rail.scrollLeft + rail.clientWidth / 2, best = Infinity, at = 0;
        figs.forEach(function (f, k) {
          var c = f.offsetLeft + f.offsetWidth / 2, d = Math.abs(c - mid);
          if (d < best) { best = d; at = k; }
        });
        if (cnt) cnt.textContent = at + 1;
        dots.forEach(function (dot, k) { dot.classList.toggle("on", k === at); });
      }, 60);
    }, { passive: true });
  });

  /* ── 顶部工序条跟随高亮 ── */
  var links = [].slice.call(document.querySelectorAll('.fc-bar-c a[href^="#stop"]'));
  var stops = links.map(function (a) { return document.querySelector(a.getAttribute("href")); });
  var bar = document.querySelector(".fc-bar-c");
  if (!bar || !("IntersectionObserver" in window)) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var i = stops.indexOf(e.target);
      if (i < 0) return;
      links.forEach(function (a, k) { a.classList.toggle("on", k === i); });
      var a = links[i];
      if (a) bar.scrollTo({ left: Math.max(0, a.offsetLeft - 16), behavior: "smooth" });
    });
  }, { rootMargin: "-45% 0px -50% 0px" });
  stops.forEach(function (s) { if (s) io.observe(s); });

  /* ── 循环片：进视口才播，离开就停 ──
     五段同时播是白费电和 CPU，而且离屏播放对买家没有任何意义。
     ⚠ play() 会返回被拒绝的 Promise（自动播放策略），必须 catch，
       否则控制台每次滚动都刷一片未处理拒绝。 */
  var loops = [].slice.call(document.querySelectorAll(".fc-vid video"));
  if (loops.length && "IntersectionObserver" in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    loops.forEach(function (v) { vio.observe(v); });
  } else {
    loops.forEach(function (v) { var p = v.play(); if (p) p.catch(function () {}); });
  }

  /* ── 完整片的海报：展开时才挂上去 ──
     五张海报合计 448 KB。收起状态下浏览器仍会去下 poster，
     所以先存在 data-poster 里，<details> 打开那一刻才赋值。 */
  [].slice.call(document.querySelectorAll(".fc-watch")).forEach(function (d) {
    d.addEventListener("toggle", function () {
      if (!d.open) return;
      var v = d.querySelector("video[data-poster]");
      if (!v) return;
      v.poster = v.getAttribute("data-poster");
      v.removeAttribute("data-poster");
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-idx"] && !Shopify.designMode) return;
  try {
    
/* Products: two views, switched by the query string.

     no parameter    landing — three line cards, none of the designs
     ?line=gates     in-line — that line's head, its series chips, its designs only

   Three things matter, all learned the hard way in the original:
     · the deep link ?line=gates&series=European+Classic from the header dropdown must
       land straight in the in-line view with the series preselected — that is where most
       of this page's traffic arrives, and breaking it wastes the click;
     · pushState, so back and forward work, with popstate reading the state back;
     · the design cards carry NO hidden attribute. The landing view hides them with CSS,
       so a crawler and a visitor without JavaScript can still read all 65. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pr-view]');
  if (!root) return;
  var grid = root.querySelector('[data-pr-grid]');
  var groups = [].slice.call(root.querySelectorAll('.pr-grp'));
  var heads = [].slice.call(root.querySelectorAll('[data-lh]'));
  var empty = root.querySelector('[data-pr-empty]');
  if (!grid || !groups.length) return;

  var LINES = heads.map(function (h) { return h.getAttribute('data-lh'); });
  var line = null, series = null;

  function paint() {
    root.setAttribute('data-pr-view', line ? 'line' : 'all');
    heads.forEach(function (h) { h.hidden = h.getAttribute('data-lh') !== line; });

    var shown = 0;
    groups.forEach(function (g) {
      var on = !!line &&
        g.getAttribute('data-line') === line &&
        (!series || g.getAttribute('data-series') === series);
      g.hidden = !on;
      if (on) shown += g.querySelectorAll('.pr-m').length;
    });
    if (empty) empty.hidden = shown > 0 || !line;

    var head = heads.filter(function (h) { return h.getAttribute('data-lh') === line; })[0];
    if (head) {
      [].forEach.call(head.querySelectorAll('.pr-st'), function (b) {
        var on = (b.getAttribute('data-series') || '') === (series || '');
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* A card that was hidden was never seen by the reveal observer, so it would sit at
       opacity 0 for ever. Nudge everything that is now on screen. */
    [].forEach.call(grid.querySelectorAll('.pr-m'), function (c) {
      if (c.offsetParent !== null) c.classList.add('in');
    });
  }

  function go(nextLine, nextSeries, push) {
    line = LINES.indexOf(nextLine) > -1 ? nextLine : null;
    series = line ? (nextSeries || null) : null;
    if (push) {
      var q = line
        ? '?line=' + encodeURIComponent(line) +
          (series ? '&series=' + encodeURIComponent(series) : '')
        : location.pathname;
      history.pushState({ line: line, series: series }, '', q);
      var t = root.querySelector(line ? '.pr-browse' : '.pl-sec');
      if (t) window.scrollTo({ top: Math.max(0, t.offsetTop - 8), behavior: 'smooth' });
    }
    paint();
  }

  root.querySelectorAll('[data-goline]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      go(a.getAttribute('data-goline'), null, true);
    });
  });
  root.querySelectorAll('[data-goall]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); go(null, null, true); });
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('.pr-st');
    if (!b || !root.contains(b)) return;
    go(line, b.getAttribute('data-series') || null, true);
  });

  function read(push) {
    var q = new URLSearchParams(location.search);
    go(q.get('line'), q.get('series'), push);
  }
  window.addEventListener('popstate', function () { read(false); });
  read(false);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rq-quote"]) return;
  try {
    
/* ═══════════════════════════════════════════════════════════
   询价页 · 分步表单
   独有交互：三个 pane 装在一条滑轨上，横向平移切换，
             顶部一条进度线跟着走；舞台高度跟着当前 pane 动。

   2026-08 重排：赵总指定第一步只问三件事 —— 地区/国家 · B 端还是 C 端 ·
   要什么产品。问完就把三个答案拼成一句话丢进 WhatsApp（pitch / paintHand），
   表单降级成备选路径，仍然不真提交。国家从「经销商那一格」提到了第一步，
   现在是全局字段。

   踩过的坑，别再踩：
   · 隐藏的 pane 不能只靠 visibility —— 键盘 Tab 还是会跳进去。
     用 inert（有就用），没有就把可聚焦元素的 tabindex 收成 -1。
   · overflow:hidden 的容器被焦点带偏时会产生 scrollLeft，必须归零。
   · 表单写了 novalidate：required 挂在看不见的 pane 上时，
     浏览器原生校验会报「元素不可聚焦」然后整个提交卡死。
   · 这一页的元素在其它页不存在，site.js 是全站共用的 —— 没有就安静退出。
   ═══════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  /* ⚠ The hook is the CLASS, not the data attribute the static page uses.
     Shopify's form tag emits only the attributes handed to it, so the
     original's bare attribute never reaches the page and this lookup returned
     null - which killed the entire wizard silently, because the very next line
     is `if (!form) return;`. `class: 'rq-form'` is passed and does survive. */
  var form = document.querySelector("form.rq-form");
  if (!form) return;                                   // 不是这一页

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  var stage = $("[data-rq-stage]");
  var track = $("[data-rq-panes]");
  var panes = $$("[data-rq-pane]");
  var fill = $("[data-rq-fill]");
  var bar = $("[data-rq-bar]");
  var stepBtns = $$("[data-rq-goto]");
  var doneBox = $("[data-rq-done]");
  var FOCUSABLE = "a[href],button,input,select,textarea,[tabindex]";

  // 对接人：Mr. Zhao 或 Tina。WhatsApp 全天在线，这一页的主路径就是它。
  var WA = "8617318547857";
  var MAIL = "info@argentgates.com";

  var ROLES = {
    contractor: {
      label: "Contractor",
      tag: "Contractor (B2B)",
      pitch: "I am a contractor pricing a project (B2B).",
      q: "What are you pricing?",
      say: "Blank fields are fine. Quotations are free; a simple CAD drawing normally comes " +
           "back the same day.",
      focusLabel: "Project"
    },
    distributor: {
      label: "Distributor",
      tag: "Distributor (B2B)",
      pitch: "I am a distributor looking at a territory (B2B).",
      q: "What would you carry?",
      say: "One dealer can hold a country, against a signed contract. Trade pricing is " +
           "issued on application, never published here.",
      focusLabel: "Market"
    },
    homeowner: {
      label: "Homeowner",
      tag: "Homeowner (B2C)",
      pitch: "This is for my own home (B2C).",
      q: "Tell us about the opening.",
      say: "Two photos and a width in millimetres get you a real answer. No minimum order — " +
           "but read the freight note at the foot of this step.",
      focusLabel: "Opening"
    }
  };

  var step = 0;
  var who = null;
  var finished = false;

  /* ── 面板可达性：inert 优先，退回 tabindex ─────────────── */
  var hasInert = "inert" in HTMLElement.prototype;
  function seal(pane, off) {
    pane.setAttribute("aria-hidden", off ? "true" : "false");
    if (hasInert) { pane.inert = !!off; return; }
    $$(FOCUSABLE, pane).forEach(function (el) {
      if (off) {
        if (!el.hasAttribute("data-rq-ti")) el.setAttribute("data-rq-ti", el.getAttribute("tabindex") || "");
        el.setAttribute("tabindex", "-1");
      } else {
        var old = el.getAttribute("data-rq-ti");
        if (old === null) return;
        if (old === "") el.removeAttribute("tabindex"); else el.setAttribute("tabindex", old);
        el.removeAttribute("data-rq-ti");
      }
    });
  }

  /* ── 舞台高度跟随当前 pane ────────────────────────────── */
  function sizeStage() {
    if (!stage || form.hidden) return;
    var pane = panes[step];
    if (!pane) return;
    stage.style.height = pane.offsetHeight + "px";
  }
  var sizeSoon = function () { requestAnimationFrame(sizeStage); };

  if ("ResizeObserver" in window) {
    var ro = new ResizeObserver(sizeSoon);
    panes.forEach(function (p) { ro.observe(p); });
  }
  addEventListener("resize", sizeSoon, { passive: true });
  addEventListener("load", sizeSoon);
  if (stage) stage.addEventListener("scroll", function () { stage.scrollLeft = 0; });

  /* ── 切步 ─────────────────────────────────────────────── */
  function paintBar() {
    var pct = finished ? 100 : [8, 46, 84][step];
    if (fill) fill.style.setProperty("--p", pct);
    stepBtns.forEach(function (b, i) {
      var on = !finished && i === step;
      var done = finished || i < step || (i === 1 && who && step > 1);
      b.classList.toggle("is-on", on);
      b.classList.toggle("is-done", !!done && !on);
      if (on) b.setAttribute("aria-current", "step"); else b.removeAttribute("aria-current");
    });
  }

  function parkView() {
    if (!bar) return;
    var top = stage.getBoundingClientRect().top;
    var lid = 64 + bar.offsetHeight + 14;
    if (top > lid - 2 && top < innerHeight * 0.5) return;   // 已经看得见，不动
    var y = stage.getBoundingClientRect().top + scrollY - lid;
    scrollTo({ top: y, behavior: reduced ? "auto" : "smooth" });
  }

  function go(i, quiet) {
    i = Math.max(0, Math.min(2, i));
    step = i;
    if (track) track.style.setProperty("--i", i);
    panes.forEach(function (p, n) { seal(p, n !== i); });
    paintBar();
    sizeStage();
    if (quiet) return;
    parkView();
    var h = $("[data-rq-focus]", panes[i]);
    if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
  }

  stepBtns.forEach(function (b) {
    b.addEventListener("click", function () {
      var to = parseInt(b.getAttribute("data-rq-goto"), 10);
      if (finished) return;
      if (to > step) { if (!advance(to)) return; return; }   // 往前要过闸
      go(to);
    });
  });

  $$("[data-rq-next]").forEach(function (b) {
    b.addEventListener("click", function () { advance(step + 1); });
  });
  $$("[data-rq-back]").forEach(function (b) {
    b.addEventListener("click", function () { go(step - 1); });
  });

  /* ⚠ Every [name=...] selector below names the RENDERED field, contact[x], not the
     static page's bare x. Shopify's contact form requires that prefix, and a selector
     for the bare name matches nothing - which made gate(0) fail forever and pinned the
     wizard on question one no matter what had been filled in. */

  /* ── 校验 ─────────────────────────────────────────────── */
  function err(key, on) {
    var p = $('[data-rq-err="' + key + '"]');
    if (!p) return;
    p.hidden = !on;
    var f = p.closest(".rq-f");
    if (f) f.classList.toggle("bad", !!on);
  }
  function val(sel) {
    var el = $(sel, form);
    return el ? String(el.value || "").trim() : "";
  }
  function looksLikeMail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  // 通过第 n 步的闸门。返回 true 表示可以往下走。
  // 第一步是赵总指定的三件事：国家 · B 端还是 C 端 · 要什么产品。
  function gate(n) {
    if (n === 0) {
      var ok = true, first = null;

      var c = val("#rq-country");
      err("country", !c);
      if (!c) { ok = false; first = first || $("#rq-country"); }

      err("who", !who);
      if (!who) { ok = false; first = first || $('input[name="contact[who]"]', form); }

      var need = $$('input[name="contact[need]"]:checked', form).length;
      err("need", !need);
      if (!need) { ok = false; first = first || $('input[name="contact[need]"]', form); }

      if (!ok && first) {
        try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
      }
      return ok;
    }
    return true;
  }

  function advance(to) {
    for (var n = step; n < to; n++) { if (!gate(n)) { go(n); return false; } }
    go(to);
    return true;
  }

  /* ── 身份 ─────────────────────────────────────────────── */
  var rows = $$("[data-rq-row]");
  function pickWho(v, quiet) {
    who = v;
    rows.forEach(function (r) {
      var on = r.getAttribute("data-rq-row") === v;
      r.classList.toggle("on", on);
      var input = $("input", r);
      if (input && on) input.checked = true;
    });
    $$("[data-rq-set]").forEach(function (s) {
      s.classList.toggle("on", s.getAttribute("data-rq-set") === v);
    });
    var role = ROLES[v];
    if (role) {
      var q = $("[data-rq-q2]"), say = $("[data-rq-say2]"), tip = $("[data-rq-tip]");
      if (q) q.textContent = role.q;
      if (say) say.textContent = role.say;
      if (tip) tip.textContent = "Step 2 is now the " + role.label.toLowerCase() +
        " sheet — optional.";
      err("who", false);
    }
    sheet();
    sizeSoon();
    if (!quiet) { /* 不自动跳步：让用户自己按 Continue，滑动才看得见 */ }
  }
  $$("[data-rq-who]").forEach(function (input) {
    input.addEventListener("change", function () {
      if (input.checked) pickWho(input.getAttribute("data-rq-who"));
    });
  });

  /* ── 芯片：没有 :has 的浏览器靠 .on ───────────────────── */
  $$(".rq-chip").forEach(function (chip) {
    var input = $("input", chip);
    if (!input) return;
    var sync = function () {
      if (input.type === "radio" && input.name) {
        $$('input[name="' + input.name + '"]', form).forEach(function (o) {
          var lab = o.closest(".rq-chip");
          if (lab) lab.classList.toggle("on", o.checked);
        });
      } else {
        chip.classList.toggle("on", input.checked);
      }
    };
    input.addEventListener("change", sync);
    sync();
  });

  /* ── 附件：只列文件名，什么都不上传 ───────────────────── */
  function kb(n) {
    if (n < 1024) return n + " B";
    if (n < 1048576) return Math.round(n / 1024) + " KB";
    return (n / 1048576).toFixed(1) + " MB";
  }
  $$("[data-rq-files]").forEach(function (input) {
    var key = input.getAttribute("data-rq-files");
    var list = $('[data-rq-filelist="' + key + '"]');
    input.addEventListener("change", function () {
      if (!list) return;
      list.innerHTML = "";
      [].slice.call(input.files || []).forEach(function (f) {
        var li = document.createElement("li");
        var a = document.createElement("span");
        a.textContent = f.name;
        var b = document.createElement("span");
        b.className = "sz";
        b.textContent = kb(f.size);
        li.appendChild(a); li.appendChild(b);
        list.appendChild(li);
      });
      sizeSoon();
    });
    var drop = input.closest("[data-rq-drop]");
    if (drop) {
      ["dragenter", "dragover"].forEach(function (e) {
        drop.addEventListener(e, function (ev) { ev.preventDefault(); drop.classList.add("over"); });
      });
      ["dragleave", "drop"].forEach(function (e) {
        drop.addEventListener(e, function () { drop.classList.remove("over"); });
      });
    }
  });

  /* ── 左栏：询价清单 ───────────────────────────────────── */
  var listBox = $("[data-rq-list]");
  var API = window.ARGENT || null;

  var SAMPLE = [
    { code: "XZS-8001", series: "Gates \u00b7 Light Luxury Minimal",
      img: "assets/products/gates/XZS-8001-1.webp" },
    { code: "YH-FN-011", series: "Fencing \u00b7 Louvre Privacy",
      img: "assets/products/fencing/YH-FN-011-1.webp" },
    { code: "YH-PV-005", series: "Pavilions \u00b7 Motorised Louvre",
      img: "assets/products/pavilions/YH-PV-005-1.webp" }
  ];

  function items() {
    if (!API || typeof API.rfq !== "function") return [];
    var v = API.rfq();
    return Object.prototype.toString.call(v) === "[object Array]" ? v : [];
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function drawList() {
    if (!listBox) return;
    var v = items();
    listBox.innerHTML = "";

    if (!v.length) {
      var e = el("div", "rq-empty");
      var p1 = el("p");
      p1.innerHTML = 'Nothing shortlisted yet. Add designs from the ' +
        /* ⚠ /pages/products, not the static site's products.html. The Liquid copy of this
   panel was converted; this one repaints over it on every load and was missed. */
        '<a class="ul" href="/pages/products">design book</a> — 65 codes, ' +
        '<span class="code">XZS-8001</span> to <span class="code">YH-PV-009</span>.';
      var p2 = el("p");
      p2.style.marginTop = "9px";
      p2.textContent = "A photo and an opening width work just as well.";
      e.appendChild(p1); e.appendChild(p2);
      if (API && typeof API.add === "function") {
        var seed = el("button", "rq-seed", "Fill with a sample shortlist");
        seed.type = "button";
        seed.addEventListener("click", function () {
          SAMPLE.forEach(function (s) { API.add(s); });
          drawList();
        });
        e.appendChild(seed);
      }
      listBox.appendChild(e);
      paintHand();
      sizeSoon();
      return;
    }

    var ul = el("ul", "rq-list");
    v.forEach(function (it) {
      var li = el("li");

      var th = el("span", "th");
      if (it.img) {
        var im = document.createElement("img");
        im.src = it.img;
        im.alt = "Catalogue render — " + (it.code || "design");
        im.loading = "lazy";
        im.width = 34; im.height = 34;
        th.appendChild(im);
      } else {
        th.className = "th none";
      }

      var mid = el("span");
      mid.appendChild(el("span", "c", it.code || "—"));
      mid.appendChild(el("span", "t", it.name || it.title || it.series || "Design"));

      var x = el("button", "rq-x");
      x.type = "button";
      x.setAttribute("aria-label", "Remove " + (it.code || "item") + " from the shortlist");
      x.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11"/></svg>';
      x.addEventListener("click", function () {
        if (API && typeof API.remove === "function") API.remove(it.code);
        drawList();
      });

      li.appendChild(th); li.appendChild(mid); li.appendChild(x);
      ul.appendChild(li);
    });
    listBox.appendChild(ul);

    if (API && typeof API.clear === "function") {
      var clr = el("button", "rq-clear", "Clear the shortlist");
      clr.type = "button";
      clr.addEventListener("click", function () { API.clear(); drawList(); });
      listBox.appendChild(clr);
    }
    paintHand();
    sizeSoon();
  }

  /* ── 左栏摘要：随填随显 ───────────────────────────────── */
  // 三个答案拼成一句话，直接丢进 WhatsApp。
  // 表单是备选，这段才是这一页真正的出口。
  function pitch() {
    var c = val("#rq-country") || "___";
    var picked = $$('input[name="contact[need]"]:checked', form).map(function (i) { return i.value; });
    var real = picked.filter(function (v) { return v !== "Not sure yet"; });
    var line = !picked.length ? "I need ___."
      : (!real.length ? "I am not sure yet which line I need."
        : "I need " + real.join(", ").toLowerCase() + ".");
    var t = "Hi Argent Gates. I am in " + c + ". " +
            (who ? ROLES[who].pitch : "I am ___.") + " " + line;
    var codes = items().map(function (i) { return i.code; }).filter(Boolean).join(", ");
    if (codes) t += " Shortlisted: " + codes + ".";
    return t;
  }

  function paintHand() {
    var t = pitch();
    $$("[data-rq-pitch]").forEach(function (n) { n.textContent = t; });
    $$("[data-rq-wa]").forEach(function (a) {
      a.href = "https://wa.me/" + WA + "?text=" + encodeURIComponent(t);
    });
    $$("[data-rq-mail]").forEach(function (a) {
      a.href = "mailto:" + MAIL +
        "?subject=" + encodeURIComponent("Enquiry from " + (val("#rq-country") || "overseas")) +
        "&body=" + encodeURIComponent(t);
    });
    // 选中哪条线，价格带就亮哪一行
    var on = {};
    $$('input[name="contact[need]"]:checked', form).forEach(function (i) { on[i.value] = 1; });
    $$("[data-rq-band]").forEach(function (li) {
      li.classList.toggle("on", !!on[li.getAttribute("data-rq-band")]);
    });
  }

  function put(node, text) {
    if (!node) return;
    var has = !!text;
    node.textContent = has ? text : node.getAttribute("data-rq-fallback") || node.textContent;
    node.classList.toggle("pending", !has);
  }
  function sheet() {
    var cy = $("[data-rq-sheet-country]"), r = $("[data-rq-sheet-role]"),
        nd = $("[data-rq-sheet-need]"), y = $("[data-rq-sheet-reply]");
    if (cy) {
      var c = val("#rq-country");
      cy.textContent = c || "Question 1";
      cy.classList.toggle("pending", !c);
    }
    if (r) {
      r.textContent = who ? ROLES[who].tag : "Question 2";
      r.classList.toggle("pending", !who);
    }
    if (nd) {
      var n = chips("need");
      nd.textContent = n || "Question 3";
      nd.classList.toggle("pending", !n);
    }
    if (y) {
      var mail = val("#rq-mail") || val("#rq-name");
      y.textContent = mail || "Step 3";
      y.classList.toggle("pending", !mail);
    }
    paintHand();
  }
  form.addEventListener("input", sheet);
  form.addEventListener("change", sheet);

  /* ── 完成态 ───────────────────────────────────────────── */
  function chips(name) {
    return $$('input[name="' + name + '"]:checked', form).map(function (i) { return i.value; }).join(", ");
  }
  function files(key) {
    var input = $('[data-rq-files="' + key + '"]', form);
    if (!input || !input.files || !input.files.length) return "";
    return [].slice.call(input.files).map(function (f) { return f.name; }).join(", ");
  }

  function recap() {
    var rows = [];
    var push = function (k, v) { if (v) rows.push([k, v]); };

    push("Who is asking", who ? ROLES[who].tag : "Not chosen");
    push("Country or region", val("#rq-country"));
    push("Product", chips("need"));

    var v = items();
    push("Shortlist", v.length
      ? v.length + " design" + (v.length > 1 ? "s" : "") + " — " +
        v.map(function (i) { return i.code; }).filter(Boolean).join(", ")
      : "None attached");

    if (who === "contractor") {
      push("Project type", val("#rq-ptype"));
      var q = val("#rq-qty"), u = $('select[name="contact[quantity_unit]"]', form);
      push("Quantity", q ? q + " " + (u ? u.value.toLowerCase() : "") : "");
      push("Needed on site", val("#rq-date"));
      push("Codes given", val("#rq-codes-c"));
      push("Scope notes", val("#rq-scope"));
      push("Drawings", files("contractor"));
    } else if (who === "distributor") {
      push("Annual volume", val("#rq-vol"));
      push("Series of interest", chips("series"));
      push("Private label", chips("private_label"));
      push("Already carries", val("#rq-carry"));
    } else if (who === "homeowner") {
      var w = val('input[name="contact[width_mm]"]'), h = val('input[name="contact[height_mm]"]');
      push("Opening", (w || h) ? (w || "?") + " × " + (h || "?") + " mm" : "");
      push("Opens", val("#rq-open"));
      push("Style direction", chips("style"));
      push("Notes", val("#rq-else"));
      push("Photos", files("homeowner"));
    }

    push("Name", val("#rq-name"));
    push("Company", val("#rq-co"));
    push("Email", val("#rq-mail"));
    push("WhatsApp", val("#rq-wa"));
    push("Reply in", val("#rq-lang"));

    var dl = $("[data-rq-recap]");
    if (!dl) return;
    dl.innerHTML = "";
    rows.forEach(function (r) {
      var d = document.createElement("div");
      d.appendChild(el("dt", null, r[0]));
      d.appendChild(el("dd", null, r[1]));
      dl.appendChild(d);
    });
  }

  function finish() {
    // 三道闸门全过一遍，哪一步坏就退回哪一步
    if (!gate(0)) { go(0); return; }
    if (!gate(1)) { go(1); return; }

    var name = val("#rq-name"), mail = val("#rq-mail"), bad = false;
    err("name", !name); if (!name) bad = true;
    var mailBad = !looksLikeMail(mail);
    err("email", mailBad); if (mailBad) bad = true;
    if (bad) {
      go(2);
      var t = !name ? $("#rq-name") : $("#rq-mail");
      if (t) t.focus();
      return;
    }

    recap();
    paintHand();
    finished = true;
    form.hidden = true;
    if (doneBox) doneBox.classList.add("on");
    paintBar();
    var f = $("[data-rq-done-focus]");
    if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
    parkView();
  }

  /* ⚠ No preventDefault. The form posts to Shopify and the completion state is shown
     by form.posted_successfully?, so the page cannot claim to have sent when it has
     not. The original had to fake this because it had nowhere to post. */
  form.addEventListener("submit", function () { try { save(); } catch (err) {} });

  var edit = $("[data-rq-edit]");
  if (edit) edit.addEventListener("click", function () {
    finished = false;
    if (doneBox) doneBox.classList.remove("on");
    form.hidden = false;
    go(2);
  });

  var restart = $("[data-rq-restart]");
  if (restart) restart.addEventListener("click", function () {
    finished = false;
    if (doneBox) doneBox.classList.remove("on");
    form.hidden = false;
    form.reset();
    who = null;
    rows.forEach(function (r) { r.classList.remove("on"); });
    $$("[data-rq-set]").forEach(function (s) { s.classList.remove("on"); });
    $$(".rq-chip").forEach(function (c) { c.classList.remove("on"); });
    $$(".rq-files").forEach(function (l) { l.innerHTML = ""; });
    $$(".rq-f.bad").forEach(function (f) { f.classList.remove("bad"); });
    $$("[data-rq-err]").forEach(function (p) { p.hidden = true; });
    $$("[data-rq-band]").forEach(function (li) { li.classList.remove("on"); });
    var q = $("[data-rq-q2]"), say = $("[data-rq-say2]"), tip = $("[data-rq-tip]");
    if (q) q.textContent = "What do you need?";
    if (say) say.textContent = "Go back one step and pick a route — this page follows it.";
    if (tip) tip.textContent = "Two more steps, both optional. The button above is the one that " +
      "works.";
    sheet();
    go(0);
  });

  /* ── 起步 ─────────────────────────────────────────────── */
  // 深链：rfq.html?who=contractor（三道门页面可以直接指过来）
  var m = /[?&]who=(contractor|distributor|homeowner)/i.exec(location.search);
  if (m) pickWho(m[1].toLowerCase(), true);

  drawList();
  sheet();
  go(0, true);
  sizeSoon();
  setTimeout(sizeStage, 400);      // 字体落位后再量一次
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-register"] && !Shopify.designMode) return;
  try {
    
/* Document register.
   Two jobs only: recount the tally from the DOM, and light the rows when the
   register scrolls into view. The row buttons route to the quote form — no file
   is ever released from the page itself.

   Section JS is bundled and runs on every page, so bail out when no register
   is present, and never assume the DOM is ready. */
(function () {
  "use strict";

  function boot() {
    var roots = [].slice.call(document.querySelectorAll(".rs[data-rs]"));
    if (!roots.length) return;

    var reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

    roots.forEach(function (root) {
      var $ = function (s, r) { return (r || root).querySelector(s); };
      var $$ = function (s, r) { return [].slice.call((r || root).querySelectorAll(s)); };

      var shelves = $$(".rs-shelf");
      if (!shelves.length) return;

      function stateOf(row) {
        var s = row.getAttribute("data-state");
        return s === "req" ? "req" : "avail";
      }
      function rowsOf(shelf) { return $$(".rs-row", shelf); }

      /* ── 1 · Tally, counted from the rows, never typed in ── */
      shelves.forEach(function (shelf) {
        var c = { all: 0, avail: 0, req: 0 };
        rowsOf(shelf).forEach(function (row) { c.all++; c[stateOf(row)]++; });
        var dl = $("[data-rs-tally]", shelf);
        if (!dl) return;
        $$("[data-t]", dl).forEach(function (dd) {
          var k = dd.getAttribute("data-t");
          if (c[k] != null) dd.textContent = c[k];
        });
      });

      /* ── 2 · A row asks for the file; it does not hand one over ── */
      var href = root.getAttribute("data-rs-rfq");
      if (href) {
        root.addEventListener("click", function (e) {
          var t = e.target;
          if (!t || !t.closest) return;
          var line = t.closest(".rs-line");
          if (!line || !root.contains(line)) return;
          window.location.href = href;
        });
      }

      /* ── 3 · Rows start at opacity 0 under .js; this turns them on ── */
      function stagger(shelf) {
        rowsOf(shelf).forEach(function (r, i) { r.style.setProperty("--i", i); });
        shelf.classList.remove("lit");
        void shelf.offsetWidth;                     /* restart the keyframes */
        shelf.classList.add("lit");
      }
      function current() { return $(".rs-shelf.is-on") || shelves[0]; }
      function firstLight() {
        var shelf = current();
        if (!shelf || shelf.classList.contains("lit")) return;
        stagger(shelf);
      }

      if (reduced) {
        shelves.forEach(function (s) { s.classList.add("lit"); });
        return;
      }

      var reg = $(".rs-reg");
      if (reg && "IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.unobserve(en.target);
            firstLight();
          });
        }, { rootMargin: "0px 0px -6% 0px", threshold: 0.02 });
        io.observe(reg);
      }

      /* Geometry fallback: IntersectionObserver is not dependable inside the
         theme editor's iframe or in old webviews. */
      var sweep = function () {
        var shelf = current();
        if (!shelf) return;
        if (shelf.classList.contains("lit")) {
          window.removeEventListener("scroll", sweep);
          return;
        }
        if (shelf.getBoundingClientRect().top < (window.innerHeight || 800) * 0.94) firstLight();
      };
      window.addEventListener("scroll", sweep, { passive: true });
      sweep();
      setTimeout(sweep, 800);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
